var _rect, _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTotalUsers = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 27C22.5674 27 24.75 24.8174 24.75 22.125C24.75 19.4326 22.5674 17.25 19.875 17.25C17.1826 17.25 15 19.4326 15 22.125C15 24.8174 17.1826 27 19.875 27Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.959 30.75C13.7081 29.5982 14.7331 28.6517 15.9409 27.9965C17.1486 27.3412 18.5009 26.998 19.8749 26.998C21.249 26.998 22.6012 27.3412 23.809 27.9965C25.0167 28.6517 26.0417 29.5982 26.7909 30.75",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 27C29.499 26.9992 30.8513 27.3418 32.0592 27.9967C33.267 28.6517 34.292 29.5981 35.0409 30.75",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3147 17.5969C26.9816 17.3309 27.6989 17.2155 28.4156 17.2589C29.1322 17.3023 29.8304 17.5035 30.4602 17.8481C31.0901 18.1926 31.6361 18.672 32.0592 19.252C32.4823 19.8321 32.7721 20.4984 32.9078 21.2034C33.0435 21.9084 33.0219 22.6346 32.8444 23.3303C32.6669 24.026 32.3379 24.6738 31.881 25.2276C31.4241 25.7814 30.8505 26.2274 30.2012 26.5338C29.5519 26.8402 28.843 26.9994 28.125 27",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTotalUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/totalUsers.a12f066f.svg";
export { ForwardRef as ReactComponent };